<template>
  <time v-if='audio' class='duration' v-html='duration ? formatMSS(duration): " "'>
    <audio ref='file' :src='audio' preload='metadata' />
  </time>
</template>

<script>
import mixins from './.././mixins.js';

export default {
  props: ['audio'],
  data: function() {
    return {
      duration: 0,
    }
  },
  mounted: function(){
    var self = this;
    this.$refs.file.addEventListener('loadedmetadata',  function() {
      self.duration = self.$refs.file.duration;
    });
  },
  methods: {
    formatMSS: function(s){
      if(s > 0) {
        s = parseInt(s);
        return (s-(s%=60))/60+(9<s?':':':0')+s
      }
      return '0:00'
    },
  }
}
</script>
